export default __webpack_public_path__ + "static/media/cake_redvelvet.d956e589.jpg";